import api from '../../services/api';

const RECURSO_ATENDIMENTO = '/atendimentos/farmacovigilancia/';
const RECURSO_CONFIG = '/programas/farmacovigilancia/configuracao/';

class FarmacovigilanciaConfigService {
    obterDoAtendimento(atendimentoId) {
        return api.get(RECURSO_ATENDIMENTO, { params: { atendimento_id: atendimentoId } });
    }

    obterConfiguracao(programaId) {
        return api.get(RECURSO_CONFIG, { params: { programa_id: programaId } });
    }

    salvarConfiguracao(programaId, configuracao) {
        return api.put(RECURSO_CONFIG, { programa_id: programaId, ...configuracao });
    }
}

const farmacovigilanciaConfigService = new FarmacovigilanciaConfigService();

export default farmacovigilanciaConfigService;
